import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import BoothsSettings from "@/components/editor/shared/expo/booths-settings/booths-settings-component";

import BoothCard from "./booth-card/booth-card-component";
import { BoothsList } from "./booths-component-styles";

type BoothsProps = {
  children?: React.ReactNode;
};

export default function Booths(props: BoothsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <div className="flex py-20">
        <BlockMaxWidthWrapper maxWidth="1248px">
          <div className="flex justify-center">
            <Element
              id="title"
              is={Text}
              text="Expo Booths"
              pattern="headingTwo"
            />
          </div>
          <BoothsList>{props.children}</BoothsList>
        </BlockMaxWidthWrapper>
      </div>
    </BlockBackgroundColorWrapper>
  );
}

Booths.craft = {
  isCanvas: true,
  custom: {
    displayName: "Booths",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: () => BoothsSettings({ template: BoothCard }),
  },
};
